// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
import TerceraCollapseLinkTemplate from '@front/templates/TerceraCollapseLinkTemplate.html';
import { Control } from './Control';
import { ThemeManager } from '../misc/ThemeManager';
import { ResourcesManager } from '@shared/commons/properties/ResourcesManager';
export class TerceraCollapseLink extends Control {
    constructor() {
        super();
    }
    oninit() {
        super.oninit();
        this.on('click', this.onClick);
        this.on('mouseOver', this.onMouseOver);
        this.on('mouseLeave', this.onMouseLeave);
        this.observe('hover', this.updateColor);
        this.observe('collapsed', this.updateImage);
        this.observe('locKey', this.updateText);
        ThemeManager.onThemeChange.Subscribe(this.themeChange, this);
        ResourcesManager.onLocaleChange.Subscribe(this.localize, this);
    }
    dispose() {
        ThemeManager.onThemeChange.UnSubscribe(this.themeChange, this);
        ResourcesManager.onLocaleChange.UnSubscribe(this.localize, this);
        super.dispose();
    }
    onMouseOver() {
        void this.set('hover', true);
        return false;
    }
    onMouseLeave() {
        void this.set('hover', false);
    }
    onClick() {
        void this.toggle('collapsed');
        return false;
    }
    updateImage() {
        const image = this.get('collapsed')
            ? 'assets/webdesktop/resources/16x16_chevron_horizontal_show_hover.png'
            : 'assets/webdesktop/resources/16x16_chevron_horizontal_hide_default.png';
        void this.set('image', image);
    }
    updateColor() {
        const color = ThemeManager.colors[this.get('hover') ? 'OE_HoveredLabelTextColor' : 'OE_RegularLabelTextColor'];
        void this.set('color', color);
    }
    updateText() {
        void this.set('text', Resources.getResource(this.get('locKey')));
    }
    themeChange() {
        this.updateImage();
        this.updateColor();
    }
    localize() {
        this.updateText();
    }
}
Control.extendWith(TerceraCollapseLink, {
    data: function () {
        return {
            width: 0,
            height: 16,
            collapsed: true,
            hover: false,
            color: '',
            text: '',
            image: '',
            locKey: ''
        };
    },
    template: TerceraCollapseLinkTemplate
});
